<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm8 offset-sm2 pt-5>
        <v-alert :value="true" v-if="error != null" type="error">{{
          error.message
        }}</v-alert>
        <v-alert :value="true" v-if="success != null" type="success">{{
          success.message
        }}</v-alert>

        <v-layout justify-center column>
          <template v-if="ready && tokenError === false">
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
              @submit="updateUser"
            >
              <h2 class="heading-2 align-left">Contact Permission</h2>

              <h2 class="heading-3 align-left">Club News</h2>
              <div class="body-copy">
                <p>
                  All the latest club news, ticketing information, retail
                  offers, rewards scheme news and competitions. Digital Ads will
                  involve us sending your data to 3rd Party companies to target
                  on our behalf.
                </p>
              </div>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch :label="`Email`" v-model="clubEmail"></v-switch>
                </v-flex>
              </v-layout>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch :label="`Mail`" v-model="clubDirect"></v-switch>
                </v-flex>
              </v-layout>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch :label="`Digital Ads`" v-model="clubAds"></v-switch>
                </v-flex>
              </v-layout>

              <h2 class="heading-3 align-left">
                {{ configStrings.clubName }} Foundation News
              </h2>
              <div class="body-copy">
                <p>
                  Keep me updated by email with the latest news from the
                  {{ configStrings.clubName }} Foundation including Football
                  Development Programmes.
                </p>
              </div>
              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch
                    :label="`Email`"
                    v-model="foundationEmail"
                  ></v-switch>
                </v-flex>
              </v-layout>

              <h2 class="heading-3 align-left">Partner News</h2>
              <div class="body-copy">
                <p>
                  Receive news, discounts, promotions and targeted
                  communications from {{ configStrings.clubName }} Football Club
                  about their Partners, Sponsors and Rewards Affiliates.
                </p>
              </div>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch :label="`Email`" v-model="partnerEmail"></v-switch>
                </v-flex>
              </v-layout>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch :label="`Mail`" v-model="partnerDirect"></v-switch>
                </v-flex>
              </v-layout>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch
                    :label="`Digital Ads`"
                    v-model="partnerAds"
                  ></v-switch>
                </v-flex>
              </v-layout>
              <div class="body-copy">
                <p>
                  <a
                    href="https://www.avfc.co.uk/club/legal/privacy-policy"
                    target="_blank"
                    >Click here</a
                  >
                  to see our current list of Partners / Sponsors. Our Partners
                  change regularly, so we update this list at least once every
                  season.
                </p>
              </div>
              <v-layout row align-center mx-1 mt-5>
                <v-spacer />
                <button
                  type="submit"
                  class="button"
                  :disabled="!valid || !ready"
                >
                  Update
                </button>
              </v-layout>
            </v-form>
          </template>

          <template v-else-if="ready && tokenError === true">
            <div class="text-xs-center">
              In order to update your prefences you must access this page from a
              valid unsubscribe link.
            </div>
          </template>
          <template v-else>
            <div class="text-xs-center">
              <v-progress-circular
                :size="50"
                color="accent"
                indeterminate
              ></v-progress-circular>
            </div>
          </template>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  name: "UserProfileContactPrefs",
  data() {
    return {
      tokenError: false,
      ready: false,
      valid: true,
      ssoid: "",
      clubAds: false,
      clubEmail: false,
      //clubSMS: false,
      //clubPhone: false,
      clubDirect: false,
      partnerEmail: false,
      //partnerSMS: false,
      //partnerPhone: false,
      partnerDirect: false,
      partnerAds: false,
      foundationEmail: false,
      error: null,
      success: null,
      loading: false,
      xcmPreferencesObject: {},
      xcmOriginalObject: {},
      token: null,
    };
  },
  created() {
    var vm = this;
    var search = location.search.substring(1);
    if (search) {
      var parameters = JSON.parse(
        '{"' +
          decodeURI(search)
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"') +
          '"}'
      );

      this.token = parameters.token; //'HkkWwQ5GjSzYcQBYLErVdw'
      if (!this.token) {
        vm.tokenError = true;
        vm.ready = true;
      } else {
        var crmXCMGetByTokenURL =
          process.env.VUE_APP_XCM_CRM_API +
          "/user/preferences/standalone/" +
          this.token;

        axios({
          method: "get",
          url: crmXCMGetByTokenURL,
        }).then(function (response) {
          if (
            response.status === 200 &&
            typeof response.data.data != "undefined"
          ) {
            vm.xcmOriginalObject = response.data.data;
            vm.xcmPreferencesObject = response.data.data.Preferences;

            vm.clubEmail =
              vm.xcmPreferencesObject["Email"]["Club Communication"] == "Y"
                ? true
                : false;
            vm.clubDirect =
              vm.xcmPreferencesObject["Direct Mail"]["Club Communication"] ==
              "Y"
                ? true
                : false;
            //vm.clubPhone = ((vm.xcmPreferencesObject['Phone']['Club Communication'] == 'Y' ) ? true : false )
            //vm.clubSMS = ((vm.xcmPreferencesObject['SMS']['Club Communication'] == 'Y' ) ? true : false )
            vm.partnerEmail =
              vm.xcmPreferencesObject["Email"]["Partner Communication"] == "Y"
                ? true
                : false;
            vm.partnerDirect =
              vm.xcmPreferencesObject["Direct Mail"]["Partner Communication"] ==
              "Y"
                ? true
                : false;
            //vm.partnerPhone = ((vm.xcmPreferencesObject['Phone']['Partner Communication'] == 'Y' ) ? true : false )
            //vm.partnerSMS = ((vm.xcmPreferencesObject['SMS']['Partner Communication'] == 'Y' ) ? true : false )
            vm.clubAds =
              vm.xcmPreferencesObject["Digital Ads"]["Club Communication"] ==
              "Y"
                ? true
                : false;
            vm.foundationEmail =
              vm.xcmPreferencesObject["Email"]["AV Foundation"] == "Y"
                ? true
                : false;
            vm.partnerAds =
              vm.xcmPreferencesObject["Digital Ads"]["Partner Communication"] ==
              "Y"
                ? true
                : false;
          } else {
            vm.tokenError = true;
          }
          vm.ready = true;
        });
      }
    } else {
      vm.tokenError = true;
      vm.ready = true;
    }
  },
  methods: {
    updateUser(e) {
      e.preventDefault();
      this.ready = false;

      this.xcmPreferencesObject["Email"]["Club Communication"] =
        this.clubEmail === true ? "Y" : "N";
      this.xcmPreferencesObject["Email"]["Partner Communication"] =
        this.partnerEmail === true ? "Y" : "N";
      this.xcmPreferencesObject["Email"]["AV Foundation"] =
        this.foundationEmail === true ? "Y" : "N";

      this.xcmPreferencesObject["Direct Mail"]["Club Communication"] =
        this.clubDirect === true ? "Y" : "N";
      this.xcmPreferencesObject["Direct Mail"]["Partner Communication"] =
        this.partnerDirect === true ? "Y" : "N";

      this.xcmPreferencesObject["Digital Ads"]["Club Communication"] =
        this.clubAds === true ? "Y" : "N";
      this.xcmPreferencesObject["Digital Ads"]["Partner Communication"] =
        this.partnerAds === true ? "Y" : "N";

      //TODO: implement this POST API in the stack
      var crmXCMGetByTokenURL =
        process.env.VUE_APP_XCM_CRM_API +
        "/user/preferences/standalone/" +
        this.token;

      var vm = this;
      var body = vm.xcmOriginalObject;
      body["Preferences"] = vm.xcmPreferencesObject;

      var config = {
        method: "post",
        url: crmXCMGetByTokenURL,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(body),
      };

      axios(config).then(function (axiosResponse) {
        //TODO: error check and response accordingly

        var response = {
          message: "Your contact preferences have been updated successfully.",
        };
        vm.success = response;
        vm.ready = true;
      });
    },
  },
};
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #eeeeee;
}
</style>